class CooperationController {
  constructor($scope, modal, message, PartnerAPI) {
    "ngInject";
    this.form = {};
    this.$scope = $scope;
    this.modal = modal;
    this.PartnerAPI = PartnerAPI
    this.message = message
  }

  submit() {
    this.$scope.form.$setSubmitted();
    
    if (this.$scope.form.$valid) {
      const data = {
        contract_route: this.form.coop,
        company: this.form.name,
        company_website: this.form.website,
        contact_name: this.form.linkman,
        contact_phone: this.form.phone,
        cooperation_method: this.form.way,
        company_email: this.form.email
      }
      this.PartnerAPI.one().post('', data)
        .then(res => {
          console.log(res)
          if (res.status.code === 200) {
            this.modal.open("success");
          } else {
            this.message.error(res.status.message[0])
          }
        })
    }
  }

  quit() {
    window.close();
  }
}

export default CooperationController;



// WEBPACK FOOTER //
// ./src/app/components/face/cooperation/cooperation.controller.js